import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadInnerComponent from './innerComponents';
import loadBlocks from './blocks';
import loadTraits from './traits';
import { colTableRef } from './consts';

export default grapesjs.plugins.add('gjs-data-group', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: 'data-group',
    blocks: [colTableRef],
    defaultStyle: true,
    labelTable: 'Data Group',
    labelCMSCategory: 'CMS',
    labelFinderName: 'Filters',
    labelColName: 'Collection',
    labelFieldName: 'Collection Fields',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadTraits(editor, options);
  loadComponents(editor, options);
  loadInnerComponent(editor, options);
  loadBlocks(editor, options);
});
